"use client";

import { atom } from "jotai";

export type Toast = {
  state: "active" | "dismissed";
  title?: string;
  type: "success" | "error" | "info" | "warning" | "loading";
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
};

export const toastAtom = atom<Toast[]>([]);
